import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Spinner } from "reactstrap"

const Spinners = ({ setLoading }) => {
  const mode = useSelector(state => state.Layout.layoutMode)
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [setLoading])
  return (
    <React.Fragment>
      <Spinner
        style={{
          color: mode === "dark" ? "#fff" : "#2990DF",
        }}
        className="position-absolute top-50 start-50"
      />
    </React.Fragment>
  )
}

export default Spinners
